import type { SingleAvailableOpportunity } from '@swf/generated/types/api/sports';

import type { BetSlipState } from '../../types/betSlip';
import { getSelectionsFromSingleOpportunities } from '../../utils/betSlip/getSelectionsFromSingleOpportunities';

import priceChangesAccepted from './priceChangesAccepted';

const selectionsReused = (state: BetSlipState): BetSlipState => ({
  ...state,
  ...priceChangesAccepted(state, state.submittedOpportunities),
  selections: getSelectionsFromSingleOpportunities(
    state.submittedOpportunities.SINGLE as SingleAvailableOpportunity[]
  )
});

export default selectionsReused;
